import React, { useCallback, useEffect, useState } from 'react'
import { Breadcrumb, MenuAccount } from '../../../components/Main'
import { useTranslation } from 'react-i18next'
import WideCardOrderCorrection from '../../../components/widecard/WideCardOrderCorrection'
import { InteractorCorrectionSearch } from '../../../interactors/Main'
import { Link } from 'react-router-dom'

const OrderCorrectionIndex = () => {
  const { t } = useTranslation()
  const pathSegments = window.location.pathname.split('/')
  const uid = pathSegments[pathSegments.length - 1]
  const { correctionSearch } = InteractorCorrectionSearch()
  const [loading, setLoading] = useState(true)
  const [download] = useState({
    headers: null,
    items: null,
    filename: null,
  })
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 5,
    keywords: {
      text_search: '',
      status: '',
      account_uid: '',
      store_uid: '',
      uid: '',
      transaction_uid: uid,
    },
  })

  const handleCsv = useCallback((data) => {
    // csvOrder(data.items, setDownload)
  }, [])

  const handleResponse = useCallback(
    (data) => {
      setDatacard(data)
      // CSV
      var payloadCsv = { ...payload }
      payloadCsv.limit = data?.pages.limit ?? 0
      correctionSearch(payloadCsv, handleCsv, () => null)
    },
    [correctionSearch, handleCsv, payload],
  )

  useEffect(() => {
    if (loading) {
      correctionSearch(payload, handleResponse, setLoading)
    }
  }, [correctionSearch, handleResponse, loading, payload])

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }

  return (
    <>
      <Breadcrumb title={t('menu.order_correction')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2 mt-0-lg">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.order_correction')}
              </h3>
              <Link
                to={'#'}
                onClick={() => {
                  window.location = `/order/view/${uid}`
                }}
                className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
              >
                <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
              </Link>
            </div>
            <hr />
            <WideCardOrderCorrection
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={false}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderCorrectionIndex
